import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import '../styles/MainSection.scss';
import smileyLogo from '../assets/smiley.png';
import logo from '../assets/Logo_white_large.png';
import stickers from '../assets/Stickers.png';

const MainSection = () => {
  const mainSectionRef = useRef(null);
  const elementsRef = useRef([]);
  const stickersRef = useRef(null);
  
  const handleCursorClick = () => {
    const phoneNumber = '+525566928386'; // Reemplaza con tu número de WhatsApp
    const message = 'Hola, me gustaría obtener más información.';
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(url, '_blank');
  };
  useEffect(() => {
    const ctx = gsap.context(() => {
      // Animación de los elementos principales
      gsap.fromTo(
        elementsRef.current,
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 1.2,
          stagger: 0.3,
          ease: 'power3.out',
        }
      );

      // Animación específica para los stickers (más lenta)
      gsap.fromTo(
        stickersRef.current,
        { opacity: 0, scale: 0.8 },
        {
          opacity: 1,
          scale: 1,
          duration: 2, // Duración más lenta
          ease: 'power3.out',
          delay: 0, // Retraso adicional antes de que inicie
        }
      );
    }, mainSectionRef);

    return () => ctx.revert(); // Limpia el contexto de GSAP al desmontar
  }, []);

  return (
    <main className="main-section" ref={mainSectionRef}>
      <span id="hey-ctn">
        <img
          id="stickers"
          src={stickers}
          alt="Stickers"
          ref={stickersRef} // Referencia específica para los stickers
        />
        <span ref={(el) => (elementsRef.current[0] = el)}>
          <h1>HEY!</h1>
          <img src={smileyLogo} alt="Smiley Logo" className="smiley" />
        </span>
      </span>
      <span
        className="we-are-ctn"
        ref={(el) => (elementsRef.current[1] = el)}
      >
        <p className="we-are">We are</p>
        <img src={logo} className="logo-large" alt="Logo" />
      </span>
      <span
        className="description-ctn"
        ref={(el) => (elementsRef.current[2] = el)}
      >
        <p className="description">
          <div >
            We believe in the power of design to tell stories, spark emotions,
            and <span className='bold'>transform the world around us.</span>
          </div>
          <span className='disapear'>
            Through unique illustrations and thoughtful design, we bring visions
            to life with passion, creativity, and originality.
          </span>
        </p>
      </span>
      <img
        id="stickers-mob"
        src={stickers}
        alt="Stickers"
        ref={stickersRef} // Referencia específica para los stickers
      />
      <span
        className="contact-ctn"
        ref={(el) => (elementsRef.current[3] = el)}
      >
        <button className="contact-button" onClick={handleCursorClick}>let's talk</button>
      </span>
    </main>
  );
};

export default MainSection;
